export { default } from "./Fade";
